import { memo, useState, useEffect, useContext } from "react";
import { Button, Divider, Grid } from "antd";
import IntlMessages from "components/Message/IntlMessages";
import ImgNextWhite from "assets/images/logo-next-white.svg";
import ImgNext from "assets/images/logo-next.svg";
import { DeviceUtil } from "utils/device-util";
import { isFalse } from "utils/common-util";
import { useIntl } from "react-intl";
import QrCode from "assets/images/QR_MNC_NEXT.PNG";
import { LoginContext } from "..";
import DangerousMessage from "components/Message/DangerousMessage";
import moment from "moment-timezone";
import { getRuntimeEnv } from "const";

const NextLogin = ({ gotoNormalLogin }) => {
  const intl = useIntl();
  const screens = Grid.useBreakpoint();
  const [isMobile, setIsMobile] = useState(false);
  const { enableLogin } = useContext(LoginContext);

  useEffect(() => {
    setIsMobile(DeviceUtil.isNotDesktop() || isFalse(screens.md));
  }, [screens.md]);

  const nextAuth = () => {
    window.open(getRuntimeEnv("REACT_APP_NEXT_AUTH_DEEP_LINK"), "_blank");
  };

  return (
    <div className="content-login-system">
      {isMobile ? (
        <>
          <div>
            <div className="d-grid py-3 ">
              <button
                data-next-login-btn
                onClick={nextAuth}
                className="btn button-ktb-next auth-next-button-anim"
                type="button"
              >
                <IntlMessages id="login.tab.normal.label.login.alternative" />
                <img src={ImgNextWhite} className="h-100 ms-1" alt="next logo" />
              </button>
            </div>
          </div>
          {enableLogin && (
            <>
              <div>
                <Divider>
                  <small>
                    <IntlMessages id="logout.or" />
                  </small>
                </Divider>
              </div>
              <div className="py-3 username-login">
                <Button className="color-label" type="primary" shape="round" ghost block onClick={gotoNormalLogin}>
                  <IntlMessages id="login.channel.username" />
                </Button>
              </div>
            </>
          )}
        </>
      ) : (
        <>
          <div className="login-qr-next">
            <div className="text-center">
              <IntlMessages id="login.home.channel" />
              <span className="mx-1">
                <img src={ImgNext} style={{ width: "55px" }} alt="Logo Next" />
              </span>
            </div>
            <div className="text-center">
              <div className="qr-signin-next my-4">
                <img src={QrCode} className="img-qr" alt="Logo Next" />
                <div className="mt-3">
                  <img src={ImgNext} style={{ width: "65px" }} alt="Logo Next" />
                </div>
              </div>
              {enableLogin && (
                <>
                  <div className="accept-login">
                    <div>
                      <DangerousMessage.Div
                        className="custom-message-1"
                        html={intl.formatMessage({
                          id: moment().isBefore(moment("1-11-2022", "DD-MM-YYYY"))
                            ? "login.username-password.warning.expire"
                            : "login.username-password.warning",
                        })}
                      />
                    </div>
                    <div>
                      <IntlMessages id="login.username-password.warning.tail" />
                    </div>
                  </div>
                  <div className="login-text">
                    <span onClick={gotoNormalLogin}>
                      <IntlMessages id="login.channel.username" />
                    </span>
                  </div>
                </>
              )}
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default memo(NextLogin);
